import { useNavigate } from 'react-router-dom';

import { NavigationService } from '../../services/navigation.service';

import { Client } from '@umanforge/common';


interface ClientProps {
  client: Client;
  t: ( key: string ) => string;
}

export function ClientComponent( props: ClientProps ) {
  const { client } = props;

  const navigate = useNavigate();

  function openDetailsClient() {
    NavigationService.toClient( navigate, client.id, false );
  }

  return (
    <div
      className="flex px-2 py-4 mx-2 my-4 shrink-0 text-center justify-center bg-gray-100 shadow-md drop-shadow-md overflow-hidden rounded-lg cursor-pointer transition ease-in-out hover:-translate-y-1 hover:scale-[105%] hover:drop-shadow-xl hover:z-10 duration-50"
      style={{ width: '26rem' }}
      onClick={ openDetailsClient }
    >
      <p className="text-lg font-semibold text-slate-600 text-left">{client.name}</p>
    </div>
  );
}